import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import euCofinanced from '@/assets/eu-cofinanced.png';
import programmeCip from '@/assets/programme-cip.png';

const Footer = () => {
  const { t, language } = useLanguage();

  const buildPath = (path: string) => {
    if (language !== 'en') {
      return path;
    }

    return path.includes('?') ? `${path}&lang=en` : `${path}?lang=en`;
  };

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-2xl font-bold mb-4">{t('Бонев ООД', 'Bonev Ltd.')}</h3>
            <p className="text-primary-foreground/80 leading-relaxed">
              {t(
                'Официален вносител в България на гръцките маслини и маслиново масло Regina. Вносители и дистрибутори на качествени средиземноморски продукти от 1991 г.',
                'Official representative in Bulgaria for Regina Greek olives and olive oil. Importers and distributors of quality Mediterranean olives since 1991.'
              )}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-4">
              {t('Бързи връзки', 'Quick Links')}
            </h4>
            <nav className="flex flex-col space-y-2">
              <Link to={buildPath('/collections')} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                {t('Колекции', 'Collections')}
              </Link>
              <Link to={buildPath('/about')} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                {t('За нас', 'About Us')}
              </Link>
              <Link to={buildPath('/contact')} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                {t('Контакти', 'Contact')}
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-4">
              {t('Контакти', 'Contact')}
            </h4>
            <div className="flex flex-col space-y-3">
              <a href="mailto:olives.bonev91@gmail.com" className="flex items-center space-x-2 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <Mail size={18} />
                <span>olives.bonev91@gmail.com</span>
              </a>
              <div className="flex items-start space-x-2 text-primary-foreground/80">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>
                  {t('Сливен, Самуиловско шосе, база Regina', 'Sliven, Samuilovsko Shose, Base Regina')}
                </span>
              </div>
              <div className="flex items-start space-x-2 text-primary-foreground/80">
                <Phone size={18} className="mt-1 flex-shrink-0" />
                <span>
                  {t('+359 884 872 770', '+359 884 872 770')}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* EU funding logos */}
        <div className="border-t border-primary-foreground/20 mt-8 pt-8 flex justify-center">
          <div className="bg-white rounded-lg px-6 py-4 flex flex-wrap items-center justify-center gap-6 sm:gap-10">
            <img src={euCofinanced} alt={t('Съфинансирано от Европейския съюз', 'Co-funded by the European Union')} className="h-10 sm:h-12 w-auto" />
            <img src={programmeCip} alt={t('Програма „Конкурентоспособност и иновации в предприятията“ 2021-2027', 'Programme "Competitiveness and Innovation in Enterprises" 2021-2027')} className="h-12 sm:h-14 w-auto" />
          </div>
        </div>

        <div className="mt-8 text-center text-primary-foreground/60 text-sm">
          <p>&copy; {new Date().getFullYear()} {t('Бонев ООД | ', 'Bonev Ltd. | ')} {t('Всички права запазени.', 'All rights reserved.')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
